import axios from 'axios'
import qs from 'qs'
//axios 配置
axios.defaults.timeout = 5000;
// axios.defaults.baseURL = 'http://192.168.0.75:8082/ktn';
axios.defaults.baseURL = 'http://127.0.0.1:8082/ktn';
// axios.defaults.baseURL = 'http://47.99.236.95:8083/ktn';
// axios.defaults.baseURL = 'http://47.99.236.95:8082/ktn';
// axios.defaults.baseURL = 'http://192.168.0.168:8082/ktn';
// axios.defaults.baseURL = 'http://192.168.0.121:8082/ktn';
// axios.defaults.baseURL = 'http://172.20.10.3:8082/ktn';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//
// // request拦截器
axios.interceptors.request.use(config => {
  // Do something before request is sent
  // const token = getCookie('');
  config.data = qs.stringify(config.data)
  // config.data = {
  // 	'Content-type':'application/x-www-form-urlencoded'
  // }
  // if(token){
  // 	config.params = {'token':token}
  // }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  return Promise.reject(error);

});
// // respone拦截器
axios.interceptors.response.use(
  response => response,
  error => {

    return Promise.reject(error);
  }
);
//post 方法
// export function post(url,data = {}){
// 	return new Promise(()=>{
// 		axios.post(url,data).then((response)=>{
// 			resolve(response.data);
// 		},err=>{
// 			reject(err);
// 		})
// 	})
// }


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response);
          },err => {
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response);
         },err => {
           reject(err)
         })
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js